import script from "./FeedTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedTab.vue?vue&type=script&setup=true&lang=ts"

import "./FeedTab.vue?vue&type=style&index=0&id=36ed525a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ed525a"]])

export default __exports__